import Chart from "react-apexcharts";

function HeatMapChart({ title, data, suffix }) {
  const series = data.data;
  const days = data.days;

  const options = {
    chart: {
      height: 350,
      type: "heatmap",
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#008FFB"],
    title: {
      text: title,
      align: "center",
    },
    yaxis: {
      labels: {
        show: true,
        offsetY: 15,
        formatter: function (value) {
          return value ? value : "19:00h";
        },
      },
    },
    xaxis: {
      type: "category",
      categories: days,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (value) {
          const round2 = (num) => Math.round(num * 100) / 100;
          return `${round2(value)}${suffix}`;
        },
      },
    },
  };

  return (
    <Chart options={options} series={series} type="heatmap" height={350} />
  );
}

export default HeatMapChart;
